
import Vue from "vue";
import {printHumanFloat, printHumanFloatDashboard} from "@/utils/pretty-print";


export default Vue.extend({
	props: {
		title: String,
		total: Number,
		className: String,
		diff: Number,
		grow: Boolean,
		allowTextOverflowDigits: Boolean
	},
	computed: {
		value():string{
			if (this.allowTextOverflowDigits){
				return printHumanFloat(this.total);
			}
			return printHumanFloatDashboard(this.total);
		}
	},
});
